module.exports = __webpack_public_path__ + "media/Images/arrow-847ccc228924e0dbaec3a739c5178e09.svg";